export default "__VITE_ASSET__De6ymTz7__"